export function scrollAppToTop(behavior: ScrollBehavior = 'instant'): void {
  window.scrollTo({ top: 0, left: 0, behavior });
  document.querySelector('.mainLayout_wrapper')?.scrollTo({ top: 0, left: 0, behavior });
}

export function scrollToHash(hash: string, behavior: ScrollBehavior = 'smooth'): boolean {
  const id = hash.replace(/^#/, '');
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior, block: 'start' });
  return true;
}

/** Retry until the target exists (e.g. after lazy route content paints). Returns cleanup. */
export function scrollToHashWhenReady(
  hash: string,
  behavior: ScrollBehavior = 'smooth',
  maxAttempts = 15,
  intervalMs = 50,
): () => void {
  const id = hash.replace(/^#/, '');
  if (!id) return () => undefined;

  let attempts = 0;
  let timer: number | undefined;

  const tick = () => {
    if (scrollToHash(`#${id}`, behavior) || attempts++ >= maxAttempts) return;
    timer = window.setTimeout(tick, intervalMs);
  };

  tick();
  return () => {
    if (timer !== undefined) window.clearTimeout(timer);
  };
}
